<script setup lang="ts">
const { currentTime, currentDuration: max, isFullscreen } = storeToRefs(useAudioStore())

const backgroundSize = computed(() => {
  const min = 0
  return `${((currentTime.value - min) / (max.value - min)) * 100}% 100%`
})

const seek = (e: Event) => {
  const target = e.target as HTMLInputElement
  currentTime.value = Number(target.value)
}
</script>

<template>
  <div
    class="flex items-center justify-center w-full gap-4 2xl:mx-10"
    :class="{
      'flex-row-reverse ': isFullscreen,
    }"
  >
    <UAudioPlaybackSpeed />
    <div class="flex items-center justify-center w-full gap-2">
      <span class="w-16 text-white text-label-xs" v-text="getMinutesAndSeconds(currentTime)" />
      <input
        :value="currentTime"
        aria-label="Lydglider"
        type="range"
        :min="0"
        :max="max"
        step="0.01"
        class="w-full min-w-32 h-[2px] bg-[var(--theme-translucent-light)] cursor-pointer bg-[linear-gradient(#FFFFFF,#FFFFFF)] bg-no-repeat transition-opacity duration-200 hover:opacity-100 appearance-none opacity-80 !max-w-[90%]"
        @input="seek"
      />
      <span class="w-16 text-white text-label-xs" v-text="getMinutesAndSeconds(max)" />
    </div>
  </div>
</template>

<style scoped lang="postcss">
input[type="range"] {
  background-size: v-bind(backgroundSize);
}

input[type="range"]::-webkit-slider-thumb {
  @apply h-[15px]
  w-[15px] appearance-none rounded-full bg-white;
}

input[type="range"]::-moz-range-thumb {
  @apply h-[15px] w-[15px] appearance-none rounded-full bg-white border-none;
}
</style>
